const parseHttpWebsiteUrl = (
  value: string | null | undefined
): URL | null => {
  const trimmedValue = (value || "").trim();

  if (!trimmedValue) {
    return null;
  }

  const valueWithProtocol = /^https?:\/\//i.test(trimmedValue)
    ? trimmedValue
    : `https://${trimmedValue}`;

  try {
    const parsedUrl = new URL(valueWithProtocol);

    if (
      !parsedUrl.hostname ||
      parsedUrl.username ||
      parsedUrl.password ||
      (parsedUrl.protocol !== "http:" && parsedUrl.protocol !== "https:")
    ) {
      return null;
    }

    return parsedUrl;
  } catch {
    return null;
  }
};

export const addHttpToUrl = (url: string | null | undefined): string =>
  parseHttpWebsiteUrl(url)?.toString() || "";

/**
 * Website Builder always lives at the tenant host's root `/admin` route.
 * Replacing the path makes this safe for values already ending in `/admin`
 * and prevents stale paths, queries, or fragments from being appended.
 */
export const getWebsiteBuilderAdminUrl = (
  websiteUrl: string | null | undefined
): string => {
  const parsedUrl = parseHttpWebsiteUrl(websiteUrl);

  // Website Builder credentials must never be entered over HTTP or through a
  // non-standard port. A bad CAP URL leaves the menu item disabled instead of
  // opening an unsafe or guessed destination.
  if (!parsedUrl || parsedUrl.protocol !== "https:" || parsedUrl.port) {
    return "";
  }

  parsedUrl.pathname = "/admin";
  parsedUrl.search = "";
  parsedUrl.hash = "";
  return parsedUrl.toString();
};

export const getMemberDirectoryProfileUrl = ({
  memberId,
  websiteUrl,
}: {
  memberId: string;
  websiteUrl: string | null | undefined;
}): string => {
  const normalizedMemberId = memberId.trim();
  const parsedUrl = parseHttpWebsiteUrl(websiteUrl);

  if (!normalizedMemberId || !parsedUrl) {
    return "";
  }

  parsedUrl.pathname = "/member-directory";
  parsedUrl.search = new URLSearchParams({ member: normalizedMemberId }).toString();
  parsedUrl.hash = "";
  return parsedUrl.toString();
};
